import React, { useEffect, useState } from "react";
import "./export.scss";
import { Button, Col, Row, Table, Tag, Typography } from "antd";
import Icon from "../../../components/icon/icon";
import { GetReportRes } from "../../../interfaces/report.interface";
import { HandleErrors } from "../../../utils/handleErrors";
import { getAllReportsService } from "../../../services/report.service";
import  Moment  from "jalali-moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";


const status: any = {
  pending : 'در انتظار پردازش',
  processing : 'در حال پردازش',
  complete : 'تکمیل شده',
  error: 'خطا'
};

const columns = [
  {
    title: "نام",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "وضعیت",
    dataIndex: "status",
    key: "status",
    render: (item: any, record: any) => (
      <div >
        {record.status === 'pending' && <Tag color={"orange"}>{status[record.status]}</Tag>}
        {record.status === 'processing' &&<Tag color={"blue"}>{status[record.status]}</Tag>}
        {record.status === 'complete' &&<Tag color={"green"}>{status[record.status]}</Tag>}
        {record.status === 'error' &&<Tag color={"red"}>{status[record.status]}</Tag>}
      </div>
    ),
  },
  {
    title: "تاریخ ثبت گزارش",
    dataIndex: "created_at",
    key: "created_at",
    render: (created_at: string)=>{
      return (<div>
        {Moment(created_at).format('jYYYY-jMM-jDD')}
      </div>)
    }
  },
  {
    title: "",
    dataIndex: "download",
    key: "download",
    render: (item: any, record: any) => (
      <>
        {record.status == 'complete' && (
          <Button href={`${(window as any).env.base_url}/reports/${record.key}.xlsx`} target="_blank" className="download">
            <Icon src="/assets/icons/Down Line.svg" />
            <Typography.Text>دانلود</Typography.Text>
          </Button>
        )}
      </>
    ),
  },
];

interface Props{
  refresh?: boolean
}

const Export = (props: Props) => {
  const health = useSelector<RootState, string>(
    (root) => root.app.health
  );
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<GetReportRes[]>([])

  useEffect(()=>{
    getData();
  },[props.refresh])

  useEffect(()=>{
    getData();
  },[])

  const getData = async ()=>{
    try {
      if(health == 'license-false'){
        return;
      }
      setLoading(true);
      const res = await getAllReportsService({});
      setData(res.list)      
      setLoading(false)
    } catch (error) {
      HandleErrors(error)
      setLoading(false)
    }
  }

  return (
    <div className="Export">
      <Row justify="start" align="middle">
        <Col>
          <Typography.Text className="title">خروجی گزارش‌ها</Typography.Text>
        </Col>

      </Row>

      <Row className="table-container">
        <Col xs={24} style={{minWidth: '800px'}}>
          <Table dataSource={data} columns={columns} loading={loading} />;
        </Col>
      </Row>


    </div>
  );
};

export default Export;
